import { SxProps } from '@mui/material'

interface ClusterStyles {
  marker: SxProps
}

export const clusterStyles: ClusterStyles = {
  marker: {
    width: 48,
    height: 48,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    border: '4px solid',
    borderColor: 'brand.primary600',
    typography: 'textSmSemibold',
    position: 'relative',
    zIndex: 1,

    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: 40,
      height: 40,
      backgroundColor: 'background.default',
      opacity: 0.8,
      borderRadius: '50%',
      zIndex: -1,
    },
  },
}
